import Vue from "vue";

import AntDesign from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

Vue.use(AntDesign);